import _definePage_default_0 from '/opt/buildhome/repo/src/pages/index.vue?definePage&vue&lang.tsx'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/opt/buildhome/repo/src/pages/account.vue?definePage&vue&lang.tsx'
import _definePage_default_3 from '/opt/buildhome/repo/src/pages/account/password.vue?definePage&vue&lang.tsx'
import _definePage_default_4 from '/opt/buildhome/repo/src/pages/account/preferences.vue?definePage&vue&lang.tsx'
import _definePage_default_5 from '/opt/buildhome/repo/src/pages/account/profile.vue?definePage&vue&lang.tsx'
import _definePage_default_6 from '/opt/buildhome/repo/src/pages/account/subscription.vue?definePage&vue&lang.tsx'
import _definePage_default_7 from '/opt/buildhome/repo/src/pages/clubdata.vue?definePage&vue&lang.tsx'
import _definePage_default_8 from '/opt/buildhome/repo/src/pages/drills/index.vue?definePage&vue&lang.tsx'
import _definePage_default_9 from '/opt/buildhome/repo/src/pages/drills/[drillSetId]/index.vue?definePage&vue&lang.tsx'
import _definePage_default_10 from '/opt/buildhome/repo/src/pages/drills/[drillSetId]/progress.vue?definePage&vue&lang.tsx'
import _definePage_default_11 from '/opt/buildhome/repo/src/pages/forgot-password.vue?definePage&vue&lang.tsx'
import _definePage_default_12 from '/opt/buildhome/repo/src/pages/login.vue?definePage&vue&lang.tsx'
import _definePage_default_13 from '/opt/buildhome/repo/src/pages/pricing.vue?definePage&vue&lang.tsx'
import _definePage_default_14 from '/opt/buildhome/repo/src/pages/protected.vue?definePage&vue&lang.tsx'
import _definePage_default_15 from '/opt/buildhome/repo/src/pages/recommendations.vue?definePage&vue&lang.tsx'
import _definePage_default_16 from '/opt/buildhome/repo/src/pages/register.vue?definePage&vue&lang.tsx'
import _definePage_default_17 from '/opt/buildhome/repo/src/pages/reports/index.vue?definePage&vue&lang.tsx'
import _definePage_default_18 from '/opt/buildhome/repo/src/pages/sessions.vue?definePage&vue&lang.tsx'
import _definePage_default_19 from '/opt/buildhome/repo/src/pages/support.vue?definePage&vue&lang.tsx'
import _definePage_default_20 from '/opt/buildhome/repo/src/pages/trends.vue?definePage&vue&lang.tsx'
import _definePage_default_21 from '/opt/buildhome/repo/src/pages/upload.vue?definePage&vue&lang.tsx'

export const routes = [
  _mergeRouteRecord(
    {
      path: '/',
      name: 'home',
      component: () => import('/opt/buildhome/repo/src/pages/index.vue'),
      /* no children */
    },
    _definePage_default_0
  ),
  _mergeRouteRecord(
    {
      path: '/account',
      name: 'account',
      component: () => import('/opt/buildhome/repo/src/pages/account.vue'),
      children: [
        {
          path: '',
          name: '/account/',
          component: () => import('/opt/buildhome/repo/src/pages/account/index.vue'),
          /* no children */
        },
        _mergeRouteRecord(
          {
            path: 'password',
            name: 'password',
            component: () => import('/opt/buildhome/repo/src/pages/account/password.vue'),
            /* no children */
          },
          _definePage_default_3
        ),
        _mergeRouteRecord(
          {
            path: 'preferences',
            name: 'account-preferences',
            component: () => import('/opt/buildhome/repo/src/pages/account/preferences.vue'),
            /* no children */
          },
          _definePage_default_4
        ),
        _mergeRouteRecord(
          {
            path: 'profile',
            name: 'account-profile',
            component: () => import('/opt/buildhome/repo/src/pages/account/profile.vue'),
            /* no children */
          },
          _definePage_default_5
        ),
        _mergeRouteRecord(
          {
            path: 'subscription',
            name: 'account-subscription',
            component: () => import('/opt/buildhome/repo/src/pages/account/subscription.vue'),
            /* no children */
          },
          _definePage_default_6
        )
      ],
    },
    _definePage_default_2
  ),
  {
    path: '/admin',
    /* internal name: '/admin' */
    /* no component */
    children: [
      {
        path: '',
        name: '/admin/',
        component: () => import('/opt/buildhome/repo/src/pages/admin/index.vue'),
        /* no children */
      }
    ],
  },
  _mergeRouteRecord(
    {
      path: '/clubdata',
      name: 'clubdata',
      component: () => import('/opt/buildhome/repo/src/pages/clubdata.vue'),
      /* no children */
    },
    _definePage_default_7
  ),
  {
    path: '/drills',
    /* internal name: '/drills' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: 'drills',
          component: () => import('/opt/buildhome/repo/src/pages/drills/index.vue'),
          /* no children */
        },
        _definePage_default_8
      ),
      {
        path: ':drillSetId',
        /* internal name: '/drills/[drillSetId]' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: '',
              name: 'drill-set',
              component: () => import('/opt/buildhome/repo/src/pages/drills/[drillSetId]/index.vue'),
              /* no children */
            },
            _definePage_default_9
          ),
          _mergeRouteRecord(
            {
              path: 'progress',
              name: 'drill-set-progress',
              component: () => import('/opt/buildhome/repo/src/pages/drills/[drillSetId]/progress.vue'),
              /* no children */
            },
            _definePage_default_10
          )
        ],
      }
    ],
  },
  _mergeRouteRecord(
    {
      path: '/forgot-password',
      name: '/forgot-password',
      component: () => import('/opt/buildhome/repo/src/pages/forgot-password.vue'),
      /* no children */
    },
    _definePage_default_11
  ),
  _mergeRouteRecord(
    {
      path: '/login',
      name: 'login',
      component: () => import('/opt/buildhome/repo/src/pages/login.vue'),
      /* no children */
    },
    _definePage_default_12
  ),
  _mergeRouteRecord(
    {
      path: '/pricing',
      name: 'pricing',
      component: () => import('/opt/buildhome/repo/src/pages/pricing.vue'),
      /* no children */
    },
    _definePage_default_13
  ),
  _mergeRouteRecord(
    {
      path: '/protected',
      name: 'protected',
      component: () => import('/opt/buildhome/repo/src/pages/protected.vue'),
      /* no children */
    },
    _definePage_default_14
  ),
  _mergeRouteRecord(
    {
      path: '/recommendations',
      name: 'recommendations',
      component: () => import('/opt/buildhome/repo/src/pages/recommendations.vue'),
      /* no children */
    },
    _definePage_default_15
  ),
  _mergeRouteRecord(
    {
      path: '/register',
      name: 'register',
      component: () => import('/opt/buildhome/repo/src/pages/register.vue'),
      /* no children */
    },
    _definePage_default_16
  ),
  {
    path: '/reports',
    /* internal name: '/reports' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: 'reports',
          component: () => import('/opt/buildhome/repo/src/pages/reports/index.vue'),
          /* no children */
        },
        _definePage_default_17
      ),
      {
        path: ':reportId',
        name: '/reports/[reportId]',
        component: () => import('/opt/buildhome/repo/src/pages/reports/[reportId].vue'),
        /* no children */
      }
    ],
  },
  _mergeRouteRecord(
    {
      path: '/sessions',
      name: 'sessions',
      component: () => import('/opt/buildhome/repo/src/pages/sessions.vue'),
      /* no children */
    },
    _definePage_default_18
  ),
  _mergeRouteRecord(
    {
      path: '/support',
      name: 'support',
      component: () => import('/opt/buildhome/repo/src/pages/support.vue'),
      /* no children */
    },
    _definePage_default_19
  ),
  _mergeRouteRecord(
    {
      path: '/trends',
      name: 'trends',
      component: () => import('/opt/buildhome/repo/src/pages/trends.vue'),
      /* no children */
    },
    _definePage_default_20
  ),
  _mergeRouteRecord(
    {
      path: '/upload',
      name: 'upload',
      component: () => import('/opt/buildhome/repo/src/pages/upload.vue'),
      /* no children */
    },
    _definePage_default_21
  ),
  {
    path: '/visualization',
    name: '/visualization',
    component: () => import('/opt/buildhome/repo/src/pages/visualization.vue'),
    /* no children */
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

